import styled from "styled-components";
import Icon from "../../../../../../../base/icons/icon/index.js";
import { FlexMixin, FontMixin } from "../../../../../../../../styles/common/mixins/helpers.styled.js";
import { BorderRadius } from "../../../../../../../../styles/common/mixins/logical.styled.js";
import { VerticalScroll } from "../../../../../../../../styles/common/mixins/scroll.styled.js";
import panelAccommodationThemes from "./themes/index.js";
export const PanelAccomodationContainer = styled.div.withConfig({
    displayName: "styled__PanelAccomodationContainer",
    componentId: "sc-afb8a162-0"
})`
	max-height: 400px;
	overflow-y: auto;
	${VerticalScroll}
`;
export const PanelAccommodationPanelBody = styled.div.withConfig({
    displayName: "styled__PanelAccommodationPanelBody",
    componentId: "sc-afb8a162-1"
})`
	padding: 20px 16px;
	${FlexMixin({
    direction: 'column'
})}
	gap: 16px;
	overflow-y: auto;
	position: relative;
`;
export const PanelAccommodationError = styled.div.withConfig({
    displayName: "styled__PanelAccommodationError",
    componentId: "sc-afb8a162-2"
})`
	padding: 16px;
	${FlexMixin({
    align: 'center',
    justify: 'center'
})}
	background-color: ${({ theme  })=>theme.colors.status.error};
	color: ${({ theme  })=>theme.colors.white.base};
	${FontMixin({
    weight: 'medium'
})}
`;
export const PanelAccommodationHeader = styled.div.withConfig({
    displayName: "styled__PanelAccommodationHeader",
    componentId: "sc-afb8a162-3"
})`
	${FlexMixin({
    justify: 'space-between'
})}
	border-bottom: 1px solid ${({ theme  })=>theme.colors.grays.light};
	padding: 16px;

	& > p {
		${FontMixin({
    size: 'base',
    weight: 'bold',
    height: 'base'
})}
		color: ${({ theme  })=>theme.colors.grays.darker};
		margin: 0;
	}
`;
export const PanelAccommodationRoomHeader = styled.div.withConfig({
    displayName: "styled__PanelAccommodationRoomHeader",
    componentId: "sc-afb8a162-4"
})`
	${FlexMixin({
    justify: 'space-between',
    align: 'center'
})}
	padding: 12px 16px;
	background-color: ${({ theme  })=>theme.colors.grays.lighter};
	border-top: 1px solid;
	border-bottom: 1px solid;
	border-color: ${({ theme  })=>theme.colors.grays.light};
	color: ${({ theme  })=>theme.colors.grays.dark};

	& > p {
		${FontMixin({
    size: 'medium',
    weight: 'regular'
})}
		text-transform: uppercase;
	}

	${({ theme  })=>panelAccommodationThemes[theme.id]?.PanelAccommodationRoomHeader?.()};
`;
export const PanelAccommodationRoomHeaderIcon = styled.div.withConfig({
    displayName: "styled__PanelAccommodationRoomHeaderIcon",
    componentId: "sc-afb8a162-5"
})`
	${BorderRadius({
    all: '50%'
})}
	${FlexMixin({
    align: 'center',
    justify: 'center'
})}
	background-color: transparent;
	color: ${({ theme  })=>theme.colors.grays.base};
	cursor: pointer;
	height: 22px;
	outline: 0;
	width: 22px;

	${Icon} {
		${FontMixin({
    size: 'base'
})}
	}

	${({ theme  })=>panelAccommodationThemes[theme.id]?.PanelAccommodationRoomHeaderIcon?.()};
`;
export const PanelAccommodationPortals = styled.div.withConfig({
    displayName: "styled__PanelAccommodationPortals",
    componentId: "sc-afb8a162-6"
})`
	position: absolute;
	top: 0;
	left: 0;
	z-index: ${({ theme  })=>theme.zIndex.highest};
`;

//# sourceMappingURL=styled.js.map